import React, { useEffect, useMemo, useState, useRef, useContext } from "react";
import Gant from './gant'
import { Progress, Spin } from 'antd';
import { FlagSvg, CheckSvg, PanelSvg, WarnSvg } from '@/components/svgs'
import { useRequest } from 'ahooks'
import { getProjectPackagesAPI, getProjectDashboardAPI, getProjectPaymentNodes, getProjectProgressAPI, getProjectMilestonesApi } from '@/services'
import { useParams } from "react-router-dom";
import { parseTime } from '@/utils'
import { ProjectDetailContext } from "../../constant"
import { getMilestoneData, MilestoneRender } from '../../milestone/index'
import { k_payStatus } from '../../paymentNodes/Timeline'
import { k_permission } from "../../project";
import ProjectProgress from "./progress/progress"
import WorktimeProgress from "./progress/worktime"
import ProjectSaturation from "./progress/saturation"
import { isDev } from "@/config";
import DepartSelectMul from "./departSelectMul"

export interface IGantHandler{
    scrollToDate: (v: Date)=>void
}
export interface PayNodeItem {
    childs: API.PROJECT.ContractPayNode[],
    date: string,
    description: string,
    statusNum: number
}
export interface ContractsGant extends API.PROJECT.Contract {
    payNodes: PayNodeItem[]
}
const k_plmUrlType = {
    unCompleted: 1 << 0,
    overDue: 1 << 1,
    allTask: 1 << 2
}

export const Schedule: React.FC = () => {
    const { contacts, permissions } = useContext(ProjectDetailContext)
    const { projectID } = useParams();
    const { data: packages = [], loading: packageLoading } = useRequest(getProjectPackagesAPI, {
        defaultParams: [Number(projectID) || 0]
    })
    const { data: progressData, loading: progressLoading } = useRequest(getProjectProgressAPI, {
        defaultParams: [Number(projectID) || 0]
    })
    const { data: mileStones = [] } = useRequest(getMilestoneData, {
        defaultParams: [projectID || 0]
    })
    const gantRef = useRef<IGantHandler>(null)
    const scrollToDate = () => {
        if (!gantRef.current || !nextPayNode) return
        gantRef.current?.scrollToDate(new Date(nextPayNode.date))
    }
    const [nextMilestone, setNextMilestone] = useState<API.Project.Package>()
    const [currentPackage, setCurrentPackage] = useState<API.Project.Package>() 
    
    const [renderPackages, setRenderPackages] = useState<API.Project.Package[]>([])
    
    useEffect(() => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        let list = packages
        if (progressData) {
            if (!progressData.standardProgress) {
                list = []
            } else {
                const ids = Object.keys(progressData.standardProgress).map(v=>Number(v))
                list = packages.filter(v => ids.includes(v.id)).map(v => {
                    const keyid = ids.find(val=>val === v.id)
                    return {
                        ...v,
                        derivedDoneRatio: keyid ? progressData.standardProgress![keyid] : v.derivedDoneRatio
                    }
                })
            }
        } else {
            list = []
        }

        setNextMilestone(list.find(v => v.typeID === 2 && v.startDate && v.dueDate && new Date(v.startDate) >= today))
        list.forEach(v => {
            if (v.typeID !== 2 && v.startDate && v.dueDate && new Date(v.startDate) < today && new Date(v.dueDate) > today) {
                setCurrentPackage(v)
            }
        })
        setRenderPackages(list)
    }, [packages, progressData])
    
    // const { } = useRequest(getProjectContractStagesAPI, {
    //     defaultParams: [Number(projectID) || 0]
    // })
    const { data: dashboardData } = useRequest(getProjectDashboardAPI, {
        defaultParams: [Number(projectID) || 0]
    })

    
    
    const [contractsGant, setContractsGant] = useState<ContractsGant[]>([])
    useEffect(() => {
        if (!contacts || !projectID) return
        
        const payNdePromsies: Promise<ContractsGant>[] = [];
        
        const curDate = new Date();
        curDate.setHours(0, 0, 0);
        const curTime = curDate.getTime();
            
        (contacts || []).forEach(v => {
            payNdePromsies.push(getProjectPaymentNodes(projectID, v.contractCode).then(res => {
                if (!res) return {
                    ...v,
                    payNodes: []
                }
                const dateMap = new Map<string, API.PROJECT.ContractPayNode[]>()
                res.forEach(payNode => {
                    const dateTime = parseTime(payNode.date, '{y}-{m}-{d}')
                    let isOutdate = false
                    const itemDate = new Date(payNode.date)
                    itemDate.setHours(0, 0, 0)

                    if (curTime > itemDate.getTime()) {
                        isOutdate = true
                    }

                    let paystatus = k_payStatus.unstart
                    if (payNode.status === "已收款") {
                        paystatus = k_payStatus.complete
                    } else if (payNode.status === "已开票") {
                        paystatus = k_payStatus.pedding
                    } else if (payNode.status === "未收款" || payNode.status === "未开票") {
                        if (isOutdate) {
                            paystatus = k_payStatus.overdue
                        }
                    }
                    dateMap.set(dateTime, (dateMap.get(dateTime) || []).concat({
                        ...payNode,
                        date: dateTime,
                        statusNum: paystatus
                    }))
                })
                // 同一合同在同一天有多收款节点，合并成一个
                const nodes: PayNodeItem[] = []
                dateMap.forEach((val, key) => {

                    let paystatus = k_payStatus.unstart
                    for (let i = 0; i < val.length; i++){
                        const item = val[i]
                        if (item.statusNum === k_payStatus.overdue) {
                            paystatus = k_payStatus.overdue
                            break
                        }
                        if (item.statusNum === k_payStatus.pedding) {
                            paystatus = k_payStatus.pedding
                            break
                        }
                        paystatus = item.statusNum
                    }
                    nodes.push({
                        date: key,
                        childs: val,
                        description: val.length > 0 ? val[0].description : "",
                        statusNum: paystatus
                    })
                })
                return {
                    ...v,
                    payNodes: nodes,
                }
            }))
        })
        Promise.all(payNdePromsies).then(vals => {
            setContractsGant(()=>vals.filter(v => !!v.contractCode || !!v.contractName))
        })

    }, [contacts])
    const nextPayNode = useMemo<API.PROJECT.ContractPayNode | undefined>(() => {
        let payNode: PayNodeItem | undefined = undefined
        const curDate = new Date()
        contractsGant.forEach(contract => {
            contract.payNodes.forEach(node => {
                const nodeDate = new Date(node.date)
                if (nodeDate > curDate) {
                    if (!payNode || (payNode && new Date(payNode.date) > nodeDate)) {
                        payNode = node
                    }
                }
            })
        })
        return payNode
    }, [contractsGant])

    const onNavigateToPlm = (val: number) => {
        let url = ""
        const unCompletedUrl = `https://plm.thape.com.cn/projects/${projectID}/work_packages?query_props=%7B%22c%22%3A%5B%22id%22%2C%22type%22%2C%22subject%22%2C%22status%22%2C%22assignee%22%2C%22startDate%22%2C%22dueDate%22%2C%22duration%22%2C%22estimatedTime%22%2C%22spentTime%22%2C%22percentageDone%22%2C%22customField6%22%2C%22relationsOfTypePrecedes%22%5D%2C%22hi%22%3Atrue%2C%22g%22%3A%22%22%2C%22dr%22%3A%22list%22%2C%22is%22%3Afalse%2C%22tv%22%3Afalse%2C%22hla%22%3A%5B%22status%22%2C%22priority%22%2C%22dueDate%22%5D%2C%22t%22%3A%22manualSorting%3Aasc%22%2C%22f%22%3A%5B%7B%22n%22%3A%22status%22%2C%22o%22%3A%22o%22%2C%22v%22%3A%5B%5D%7D%2C%7B%22n%22%3A%22dueDate%22%2C%22o%22%3A%22%3Ct%2B%22%2C%22v%22%3A%5B%227%22%5D%7D%5D%2C%22ts%22%3A%22PT0S%22%2C%22pp%22%3A250%2C%22pa%22%3A1%7D`
        const overDueUrl = `https://plm.thape.com.cn/projects/${projectID}/work_packages?query_props=%7B%22g%22%3A%22%22%2C%22hi%22%3Afalse%2C%22t%22%3A%22createdAt%3Adesc%22%2C%22c%22%3A%5B%22id%22%2C%22type%22%2C%22subject%22%2C%22status%22%2C%22startDate%22%2C%22dueDate%22%2C%22duration%22%5D%2C%22f%22%3A%5B%7B%22n%22%3A%22dueDate%22%2C%22o%22%3A%22%5Cu003ct-%22%2C%22v%22%3A%5B%221%22%5D%7D%2C%7B%22n%22%3A%22status%22%2C%22o%22%3A%22o%22%2C%22v%22%3A%5B%5D%7D%5D%7D&name=overdue`
        const allTaskUrl = `https://plm.thape.com.cn/projects/${projectID}/work_packages?query_props=%7B"c"%3A%5B"id"%2C"type"%2C"subject"%2C"status"%2C"assignee"%2C"startDate"%2C"dueDate"%2C"duration"%2C"estimatedTime"%2C"spentTime"%2C"percentageDone"%2C"customField6"%2C"relationsOfTypePrecedes"%5D%2C"hi"%3Atrue%2C"g"%3A""%2C"is"%3Afalse%2C"tv"%3Afalse%2C"hla"%3A%5B"status"%2C"priority"%2C"dueDate"%5D%2C"t"%3A"id%3Aasc"%2C"f"%3A%5B%7B"n"%3A"status"%2C"o"%3A"%3D"%2C"v"%3A%5B"8"%5D%7D%5D%2C"ts"%3A"PT0S"%2C"pp"%3A100%2C"pa"%3A1%7D`
        if (val === k_plmUrlType.unCompleted) {
            url = unCompletedUrl
        } else if (val === k_plmUrlType.overDue) {
            url = overDueUrl
        } else if (val === k_plmUrlType.allTask) {
            url = allTaskUrl
        }
        window.open(url, "_blank")
    }
    const hasProjectProgressPermission = useMemo(() => {
        return permissions && permissions.includes(k_permission.dashboardOverallView)
    }, [permissions])
    return (
        <div> 
            {/* <div className="py-2 border-0 border-b border-solid border-gray-200 font-bold">进度总览</div> */}
            <div className="">
                <div className="flex justify-between text-xs">
                    <div className="flex items-center">
                        {currentPackage && (
                            <div><span className="font-bold">当前阶段：</span>{currentPackage.subject}</div>
                        )}
                        {nextMilestone && (
                            <div><span className="font-bold ml-2">下一里程碑：</span>{nextMilestone?.subject}</div>
                        )}
                        {nextPayNode && (
                            <div><span className="font-bold ml-2">下一收款节点：</span><span onClick={scrollToDate} className="hover:font-bold cursor-pointer">{nextPayNode.date} {nextPayNode?.description}</span></div>
                        )}
                    </div>
                </div>
                <div className="flex my-6">
                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3">
                        {hasProjectProgressPermission && (
                            <div className="flex flex-1 items-center mr-1">
                                <Progress type="circle" size={40} strokeWidth={16} strokeColor="#475dae" percent={Number(progressData?.projectProgress || 0)} format={(_) => ""} />
                                <div className="ml-2">
                                    <div className="font-bold text-lg">{progressData ? `${progressData.projectProgress}%` : "-"}</div>
                                    <div className="text-xs text-gray-500">项目总进度</div>
                                </div>
                            </div>
                        )}
                        
                        <div className="flex flex-1 items-center">
                            <Progress type="circle" size={40} strokeWidth={16} strokeColor="#475dae" percent={Number(progressData?.selfProjectProgress || 0)} format={(_) => ""} />
                            <div className="ml-2">
                                <div className="font-bold text-lg">{progressData ? `${progressData.selfProjectProgress}%` : "-"}</div>
                                <div className="text-xs text-gray-500">专业团队进度</div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3">
                        <Progress type="circle" size={40} strokeWidth={16} strokeColor="#92400e" percent={dashboardData?.paymentProgress || 0} format={(_) => ""} />
                        <div className="ml-2">
                            <div className="font-bold text-lg">{dashboardData?.paymentProgress}%</div>
                            <div className="text-xs text-gray-500">收款进度</div>
                        </div>
                    </div>
                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3">
                        <Progress type="circle" size={40} strokeWidth={16} strokeColor="#92400e" percent={dashboardData?.invoiceProgress || 0} format={(_) => ""} />
                        <div className="ml-2">
                            <div className="font-bold text-lg">{dashboardData?.invoiceProgress}%</div>
                            <div className="text-xs text-gray-500">开票进度</div>
                        </div>
                    </div>
                    {nextMilestone && (
                        <div className="flex grow shrink-0 basis-0 items-center justify-center p-3">
                            <div className="shrink-0 w-[40px] h-[40px] rounded-full bg-orange-900/30 text-[20px] text-orange-800 flex items-center justify-center">
                                <FlagSvg />
                            </div>
                            <div className="flex-1 w-0 ml-2 text-ellipsis overflow-hidden">
                                <div className="font-bold whitespace-nowrap text-ellipsis overflow-hidden">{nextMilestone?.subject}</div>
                                <div className="text-xs text-gray-500">近期里程碑</div>
                            </div>
                        </div>
                    )}

                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3 cursor-pointer hover:bg-gray-100" onClick={() => onNavigateToPlm(k_plmUrlType.unCompleted)}>
                        <div className="shrink-0 w-[40px] h-[40px] rounded-full bg-orange-500/30 text-[25px] text-orange-500 flex items-center justify-center">
                            <WarnSvg />
                        </div>
                        <div className="ml-2">
                            <div className="font-bold text-lg">{dashboardData?.expireTaskCount}个</div>
                            <div className="text-xs text-gray-500">将到期任务数</div>
                        </div>
                    </div>
                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3 cursor-pointer hover:bg-gray-100" onClick={() => onNavigateToPlm(k_plmUrlType.overDue)}>
                        <div className="shrink-0 w-[40px] h-[40px] rounded-full bg-red-500/30 text-[20px] text-red-500 flex items-center justify-center">
                            <PanelSvg />
                        </div>
                        <div className="ml-2">
                            <div className="font-bold text-lg">{dashboardData?.overdueTaskCount}个</div>
                            <div className="text-xs text-gray-500">逾期任务数</div>
                        </div>
                    </div>
                    <div className="flex grow shrink-0 basis-0 items-center justify-center p-3 cursor-pointer hover:bg-gray-100" onClick={()=>onNavigateToPlm(k_plmUrlType.allTask)}>
                        <div className="shrink-0 w-[40px] h-[40px] rounded-full bg-sky-900/30 text-[25px] text-sky-800 flex items-center justify-center">
                            <CheckSvg />
                        </div>
                        <div className="ml-2">
                            <div className="font-bold text-lg">{dashboardData?.doneTaskCount} / {(dashboardData?.doneTaskCount || 0) + (dashboardData?.undoneTaskCount || 0)}个</div>
                            <div className="text-xs text-gray-500">已完成任务数</div>
                        </div>
                    </div>
                </div>
                <Spin spinning={packageLoading || progressLoading}>
                    <div>
                    <Gant ref={gantRef} data={renderPackages} contacts={contractsGant} milestones={mileStones} />
                    </div>
                </Spin>
            </div>
        </div>
    )
}

export const NewSchedule: React.FC = () => {
    const { projectID } = useParams();
    const [selectedDeparts, setSelectedDeparts] = useState<string[]>([])
    const onDepartChange = (opt: API.Project.DashboardCostMajor[]) => {
        // run(projectID || "", `${opt.professioncomcode},${opt.professiondeptcode},${opt.profession}`)
        setSelectedDeparts(opt.map(v => `${v.professioncomcode},${v.professiondeptcode},${v.profession}`))
        
    }

    return (
        <div>
            <div className="flex items-center mb-4">
                <span className="mr-2">部门专业筛选: </span>
                <DepartSelectMul projectID={projectID || ""} onChange={onDepartChange} />
            </div>
            {<ProjectProgress projectID={projectID || 0} departs={selectedDeparts} />}
            {<WorktimeProgress projectID={projectID || 0} departs={selectedDeparts} />}
            {<ProjectSaturation projectID={projectID || 0} departs={selectedDeparts} />}
        </div>
    )
}